const initialState = {
    dataSkillsSelectable: []
}

const skillReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_SKILL_SELECTABLE':
            return {
                ...state,
                dataSkillsSelectable: action.payload
            }
        default:
            return state
    }
}

export default skillReducer
